import { jsx as o } from "react/jsx-runtime";
import { D as e } from "../sortable.esm-c91ac06a.js";
import l from "./SortableItem.js";
const i = ({ activeId: r, children: t }) => r ? /* @__PURE__ */ o(e, { children: /* @__PURE__ */ o(l, { id: r, children: t }) }) : null;
export {
  i as default
};
//# sourceMappingURL=SortableOverlay.js.map
